// @ts-nocheck
import {
  useState, useEffect, useCallback
} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  INITIALIZE_ACCOUNT, SET_PERSONAS, UPDATE_ACCOUNT
} from '../store/actions';
import config from '../config';
import {Client} from '../client';

export function useAccountInitialization() {
  const account = useSelector((state) => state.account);
  const profile = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const [accountState, setAccountState] = useState({
    config: null,
    clients: [],
    loading: true,
    error: null,
    initialized: false
  });

  const initializeAccount = useCallback(async () => {
    if (!account || account.initialized) return;

    try {
      setAccountState((prev) => ({
        ...prev, loading: true, error: null
      }));

      console.log('Loading Account: ', config);
      console.log(' - Getting: ' + `accounts/${config.account.id}`);

      const client = new Client();
      const accountConfig = await client.getAccount();

      if (accountConfig) {
        console.log(' - Account Config: ', accountConfig);

        let activeClientId = accountConfig.defaultClient || 'default';

        if (profile?.selected) {
          activeClientId = profile.selected.client;
        }

        const allClients = Object.keys(accountConfig.configs)
          .filter((clientId) => accountConfig.configs[clientId].active)
          .map((clientId) => accountConfig.configs[clientId]);

        setAccountState({
          config: {
            ...accountConfig,
            defaultClient: activeClientId
          },
          clients: allClients,
          loading: false,
          error: null,
          initialized: true
        });

        // Still dispatch to Redux if needed
        dispatch({
          type: INITIALIZE_ACCOUNT,
          payload: {
            config: {
              ...accountConfig,
              defaultClient: activeClientId
            },
            clients: allClients
          }
        });
      }
    } catch (error) {
      setAccountState((prev) => ({
        ...prev,
        loading: false,
        error: error.message
      }));
    }
  }, [account]);

  useEffect(() => {
    initializeAccount();
  }, [initializeAccount]);

  return {
    ...accountState,
    refetch: initializeAccount
  };
}

export const useAccountInitializationAdmin = () => {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const profile = useSelector((state) => state.profile);

  // [INIT] Load account data
  useEffect(() => {
    // [1]
    if (account && !account.initialized) {
      const client = new Client();

      const getAccountAdmin = async () => {
        const accountConfig = await client.getAccountAdmin();

        // Check for existence
        if (accountConfig) {
          console.log(' - Account Config: ', accountConfig);

          // Select active client
          let activeClientId = accountConfig.defaultClient
            ? accountConfig.defaultClient
            : 'default';

          // Check for selection override
          if (profile && profile.selected) {
            activeClientId = profile.selected.client;
          }

          // Extract client data
          const allClients = [];
          Object.keys(accountConfig.configs).map((clientId) => {
            if (accountConfig.configs[clientId].active) {
            // Add to roster
              allClients.push(
                accountConfig.configs[clientId]
              );
            }
          });

          // Initialize account
          dispatch({
            type: INITIALIZE_ACCOUNT,
            payload: {
              config: {
                accountId: accountConfig.accountId,
                atlasUrl: accountConfig.atlasUrl,
                name: accountConfig.name,
                version: accountConfig.version,
                defaultClient: activeClientId,
                events: accountConfig.events
              },
              clients: allClients
            }
          });
        }
      }

      getAccountAdmin();
    }
  }, [profile, account]);
};

// Load Personas
export function useActiveAccount() {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const profile = useSelector((state) => state.profile);
  const knowledge = useSelector((state) => state.knowledge);

  useEffect(() => {
    console.log('usePersonas - account:', account);
    console.log('usePersonas - profile:', profile);
    console.log('usePersonas - knowledge:', knowledge);

    const getAccountPersonas = async () => {
      if (
        account.initialized
        && profile.initialized
        && knowledge.entities
        && knowledge.entities.length === 0
        && knowledge.attempts < 3
      ) {
        console.log('Loading Personas: ', account, profile);

        // Select active cli  ent
        let activeClientId = account.config.defaultClient
          ? account.config.defaultClient
          : 'default';
        let activeClient = null;
        const availableClients = [];

        // Check for selection override
        for (let i = 0; i < account.clients.length; i++) {
        // Check for active
          if (profile.user.selected) {
          // Check for active client
            if (account.clients[i].id == profile.user.selected.client) {
            // Set active client and ID
              activeClient = account.clients[i];
              activeClientId = account.clients[i].id;
            } else {
            // Add to roster
              availableClients.push(account.clients[i]);
            }
          // Check for active clientx
          } else if (account.clients[i].id == activeClientId) {
          // Set active client and ID
            activeClient = account.clients[i];
            activeClientId = account.clients[i].id;
          } else {
          // Add to roster
            availableClients.push(account.clients[i]);
          }
        }

        const client = new Client();
        const personas = await client.getAccountPersonas(account, activeClientId);

        // Update personas
        dispatch({
          type: SET_PERSONAS,
          payload: personas
        });

        // Update account
        dispatch({
          type: UPDATE_ACCOUNT,
          payload: {
            active: activeClient,
            available: availableClients
          }
        });
      }
    }

    getAccountPersonas();
  }, [account, profile, knowledge]);
}
